module.exports = __webpack_public_path__ + "static/media/bim.7e4e3c25.png";